export default "__VITE_ASSET__DRPsbGYJ__"